import React, { useEffect, useRef, useState } from 'react';

function Spy(props) {
    const ref = useRef(null);

    useEffect(() => {
        const node = ref.current;
        if (node != null) {
            node.observer = new IntersectionObserver((entries) => {
                entries.forEach(entry => {
                    if (entry.isIntersecting) {
                        props.setIndex(prev => prev + props.increment);
                    }
                });
            });
            node.observer.observe(node);
        }
        
        return () => node && node.observer.disconnect();
    }, []);

    return <xs-spy ref={ref}></xs-spy>;
}

export default function RenderOnScroll(props) {
    const [index, setIndex] = useState(props.start || 0);
    const children = props.children;
    
    return (
        <>
            {children?.slice(0, index)}
            {index <= children.length &&
                <Spy key={index} increment={props.increment || 1} setIndex={setIndex} />
            }
        </>
    );
}
